module.exports = __webpack_public_path__ + "static/media/greytick.b030f072.svg";